var _rect, _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoFoundImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 202,
    viewBox: "0 0 202 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 79.5723,
    y: 65,
    width: 55.2857,
    height: 54,
    rx: 6,
    fill: "#E4EFF3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4606_15935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.572 89H106.601",
    stroke: "#A2B4B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.572 77H82.5723C77.6017 77 73.5723 81.0294 73.5723 86V116C73.5723 120.971 77.6017 125 82.5723 125H112.572C117.543 125 121.572 120.971 121.572 116V86C121.572 81.0294 117.543 77 112.572 77Z",
    stroke: "#A2B4B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5723 110L85.5723 98.0001C86.9404 96.6836 88.4924 95.9905 90.0723 95.9905C91.6521 95.9905 93.2041 96.6836 94.5723 98.0001L109.572 113",
    stroke: "#A2B4B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.572 107L106.572 104C107.94 102.684 109.492 101.99 111.072 101.99C112.652 101.99 114.204 102.684 115.572 104L121.572 110",
    stroke: "#A2B4B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 125.428H51.2857",
    stroke: "#A2B4B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150.285 65H160.571",
    stroke: "#A2B4B9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4606_15935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(61.5723 65)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFoundImg);
export default __webpack_public_path__ + "static/media/NoFoundIMG.369520dbfd6bb2d835776e2de16400df.svg";
export { ForwardRef as ReactComponent };